import { cloneDeep } from 'lodash-es'

const defaultState = () => ({
  loading: false,
  ssrBags: [],
  ssrOthers: [],
  seatMapData: [],
  error: null,
  isRetryLoadingAncillary: false,
  isRetryLoadingSeatMap: false,
  isLoadingDraftBooking: false,
  isHideFunction: false,

  paxAddonsData: [],
  paxSeatData: [],
})

export default {
  namespaced: true,
  state: {
    ...defaultState(),
  },

  // =============================== GETTERS =============================== //
  getters: {
    getLoading: state => state.loading,
    getSsrBags: state => state.ssrBags,
    getSsrOthers: state => state.ssrOthers,
    getSeatMapData: state => state.seatMapData,
    getError: state => state.error,
    getIsRetryLoadingAncillary: state => state.isLoadingDraftBooking || state.isRetryLoadingAncillary,
    getIsRetryLoadingSeatMap: state => state.isLoadingDraftBooking || state.isRetryLoadingSeatMap,
    getEnableRetryAddons: state => !state.isLoadingDraftBooking && !state.isRetryLoadingAncillary && !state.isRetryLoadingSeatMap,
    getAddonsData: state => state.paxAddonsData,
    getPaxSeatData: state => state.paxSeatData,
    getSelectedSeatsDetails: state => {
      const seatSelectedFilter = state.paxSeatData.filter(s => s.seat !== null)
      return seatSelectedFilter
    },
    getIsHideFunction: state => state.isHideFunction,
  },

  // =============================== MUTATIONS =============================== //
  mutations: {
    RESET_CREATE_BOOKING_STORE(state) {
      Object.assign(state, { ...defaultState() })
    },
    SET_SSR_BAGS(state, bags) {
      state.ssrBags = bags
    },
    SET_SSR_OTHERS(state, others) {
      state.ssrOthers = others
    },
    SET_SEAT_MAP_DATA(state, seatMap) {
      state.seatMapData = seatMap
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_RETRY_LOADING_ANCILLARY(state, isLoading) {
      state.isRetryLoadingAncillary = isLoading
    },
    SET_RETRY_LOADING_SEAT_MAP(state, isLoading) {
      state.isRetryLoadingSeatMap = isLoading
    },
    SET_LOADING_DRAFT_BOOKING(state, isLoading) {
      state.isLoadingDraftBooking = isLoading
    },

    SET_ADDONS_SELECT_DATA(state, val) {
      state.paxAddonsData = val
    },
    SET_DEFAULT_DATA_PAX_SEAT(state, val) {
      state.paxSeatData = val
    },
    SET_SEAT_SELECT(state, val) {
      state.paxSeatData[val.index].seat = val.seat
    },
    RESET_DATA_TRIPS(state) {
      state.paxSeatData = []
    },
    SET_IS_HIDE_FUNCTION(state) {
      state.isHideFunction = !state.isHideFunction
    },
  },

  // =============================== ACTIONS =============================== //
  actions: {
    setSsrBags({ commit }, bags) {
      commit('SET_SSR_BAGS', bags)
    },
    setSsrOthers({ commit }, others) {
      commit('SET_SSR_OTHERS', others)
    },
    setSeatMapData({ commit }, seatMap) {
      commit('SET_SEAT_MAP_DATA', seatMap)
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },
    setRetryLoadingAncillary({ commit }, isLoading) {
      commit('SET_RETRY_LOADING_ANCILLARY', isLoading)
    },
    setRetryLoadingSeatMap({ commit }, isLoading) {
      commit('SET_RETRY_LOADING_SEAT_MAP', isLoading)
    },
    setLoadingDraftBooking({ commit }, isLoading) {
      commit('SET_LOADING_DRAFT_BOOKING', isLoading)
    },
    resetCreateBookingStore({ commit }) {
      commit('RESET_CREATE_BOOKING_STORE')
    },

    // ANCHOR reservation
    setAddonsSelectData({ commit }, val) {
      commit('SET_ADDONS_SELECT_DATA', val)
    },
    setDefaultDataPaxSeat({ commit }, val) {
      commit('SET_DEFAULT_DATA_PAX_SEAT', val)
    },
    handleSeatSelect({ getters, commit, dispatch }, selectedSeat) {
      const passengerSeatData = getters.getPaxSeatData

      const getData = (valueCheck, type = '') => {
        if (type === 'filter') {
          return passengerSeatData.filter(item => {
            if (['VN'].includes(selectedSeat.airline)) {
              return (item.segment.segmentFlights === selectedSeat.segmentFlights)
                  && (item.segment.airlineItineraryId === selectedSeat.itineraryId)
                  && (item.segment.source === selectedSeat.source)
            }
            return (item.segment.segmentFlights === selectedSeat.segmentFlights)
                && (item.segment.source === selectedSeat.source)
          })
        }

        return passengerSeatData.findIndex(item => {
          if (['VN'].includes(selectedSeat.airline)) {
            return item.segment.segmentFlights === valueCheck.segment.segmentFlights
                  && item.passenger.paxId === valueCheck.passenger.paxId
                  && item.segment.airlineItineraryId === valueCheck.segment.airlineItineraryId
          }
          return item.segment.segmentFlights === valueCheck.segment.segmentFlights
                && item.passenger.paxId === valueCheck.passenger.paxId
        })
      }

      let data = null
      const passengersInSameSegment = getData(null, 'filter')

      switch (true) {
        case passengersInSameSegment.every(p => p.seat !== null): {
          const existingSeat = passengersInSameSegment.find(p => p.seat && p.seat.seat.seatName === selectedSeat.seat.seatName)
          if (existingSeat) {
            const passengerIndex = getData(existingSeat)
            data = {
              index: passengerIndex,
              seat: null,
            }
          }
          break
        }
        case passengersInSameSegment.every(p => p.seat === null): {
          const passengerIndex = getData(passengersInSameSegment[0])
          data = {
            index: passengerIndex,
            seat: selectedSeat,
          }
          break
        }
        default: {
          const existingSeat = passengersInSameSegment.find(p => p.seat && p.seat.seat.seatName === selectedSeat.seat.seatName)
          if (existingSeat) {
            const passengerIndex = getData(existingSeat)
            data = {
              index: passengerIndex,
              seat: null,
            }
          } else {
            const passengerWithoutSeat = passengersInSameSegment.find(p => p.seat === null)
            const passengerIndex = getData(passengerWithoutSeat)
            data = {
              index: passengerIndex,
              seat: selectedSeat,
            }
          }
          break
        }
      }

      if (data) {
        if (selectedSeat.ssrOtherLEGX) {
          if (data.seat) { // data.seat => thêm mới => thêm ssr
            const pax = passengerSeatData[data.index].passenger
            const ssrToAdd = {
              ...selectedSeat.ssrOtherLEGX,
              paxId: pax.paxId,
              firstName: pax.firstName || '',
              lastName: pax.lastName || '',
              paxType: pax.paxType,
            }
            const dataSsr = getters.getAddonsData
            dataSsr.push(ssrToAdd)
            dispatch('setAddonsSelectData', dataSsr)
          } else { // k có data.seat > xoá ghế => xoá ssr (bookingPriceDetail, seatMap > xoá ghế)
            const ssrDel = selectedSeat.ssrOtherLEGX
            const dataSsr = cloneDeep(getters.getAddonsData)
            const indexSsrDel = getters.getAddonsData.findIndex(it => it.paxId === ssrDel.paxId && it.flights === ssrDel.flights && it.code === ssrDel.code && it.segmentId === ssrDel.segmentId)
            dataSsr.splice(indexSsrDel, 1)
            dispatch('setAddonsSelectData', dataSsr)
          }
        }

        commit('SET_SEAT_SELECT', data)
      }
    },
    resetDataTrips({ commit }) {
      commit('RESET_DATA_TRIPS')
    },
    toggleHideFunction({ commit }) {
      commit('SET_IS_HIDE_FUNCTION')
    },
  },
}
